
var id = "menu_copon";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"menu_copon\">\n<path d=\"M197.8,131.3l-16.4-31.9c-2.3-4-6.5-4.5-11.1-4.5h-36.8c-5,0-9.6,0.7-12.1,5l-16.1,31.3c-2.5,4.3-2.5,9.6,0,13.9l16.1,31.3\n\tc2.5,4.3,7.1,6,12.1,6h36.2c5,0,9.6-1.7,12.1-6l16.1-31.3C200.3,141,200.3,135.6,197.8,131.3L197.8,131.3z M170.4,173.2h-37.7\n\tl-19.8-34.9l19.8-33.9h37.7l19.8,33.9L170.4,173.2z\" />\n<path d=\"M151.6,121c-9.5,0-17.2,7.7-17.2,17.2c0,9.5,7.7,17.2,17.2,17.2s17.2-7.7,17.2-17.2C168.8,128.8,161.1,121,151.6,121\n\tL151.6,121z M151.6,144.2c-1.7,0-5.9,0-5.9-5.9c0-1.7,0-5.9,5.9-5.9c1.7,0,5.9,0,5.9,5.9C157.5,140,157.5,144.2,151.6,144.2z\" />\n<path d=\"M82.5,160.5c-2.1,0-4-1-5.2-2.7c-4.9-6.5-12.5-10.4-20.8-10.4c-8.2,0-15.9,3.9-20.8,10.4c-1.2,1.7-3.2,2.7-5.2,2.7H20\n\tc-3.6,0-6.5-2.9-6.5-6.5V36c0-3.6,2.9-6.5,6.5-6.5h10.9c2.1,0,4,1,5.2,2.6c4.9,6.4,12.5,10.3,20.7,10.3s15.8-3.9,20.7-10.3\n\tc1.2-1.6,3.2-2.6,5.2-2.6h85.5c3.6,0,6.5,2.9,6.5,6.5v48.1c0,3.6,2.9,6.5,6.5,6.5c3.6,0,6.5-2.9,6.5-6.5V33.5\n\tc0-9.3-7.6-16.9-16.9-16.9H75c-2.8,0-5.3,1.7-6.2,4.3c-1.8,5.1-6.6,8.7-12.3,8.7S46.1,26,44.3,21c-0.9-2.6-3.5-4.3-6.2-4.3H17.4\n\tc-9.3,0-16.9,7.5-16.9,16.8v123.1c0,9.3,7.6,16.9,16.9,16.9h21c2.7,0,5.2-1.7,6.1-4.3c2.3-6.6,9.7-10.7,17.4-7.7\n\tc4.8,1.9,7.8,6.5,7.8,11.6v0.4h31.3c3.6,0,6.5-2.9,6.5-6.5c0-3.6-2.9-6.5-6.5-6.5L82.5,160.5z\" />\n<path d=\"M58.2,63.6h-4.9c-2.7,0-4.9,2.2-4.9,4.9v19.5c0,2.7,2.2,4.9,4.9,4.9h4.9c2.7,0,4.9-2.2,4.9-4.9V68.5\n\tC63.1,65.8,60.9,63.6,58.2,63.6z M58.2,107.4h-4.9c-2.7,0-4.9,2.2-4.9,4.9v19.5c0,2.7,2.2,4.9,4.9,4.9h4.9c2.7,0,4.9-2.2,4.9-4.9\n\tv-19.5C63.1,109.6,60.9,107.4,58.2,107.4L58.2,107.4z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
